// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"72":"Cart","187":"NotFound","189":"LoginPagas","363":"FullArmor","494":"Register"}[chunkId] || chunkId) + "." + {"72":"7063d579","187":"7439b3e2","189":"f048c619","363":"b9936b41","494":"69a8502a","591":"87f82080"}[chunkId] + ".chunk.js";
};